<template>
  <div class="my-scores">
    <div class="score-top">
      <div class="top-top">
        <div class="top-num">{{formData.balance || 0}}</div>
        <div class="top-s">积分余额</div>
        <div class="top-but" @click="withdrawal"></div>
      </div>
      <div class="top-sta">
        <div class="sta-div">
          <div>本月收入：{{formData.monthIncome || 0}}分</div>
          <div>总收入：{{formData.totalAmount || 0}}分</div>
        </div>
        <div class="sta-div">
          <div>本月提现：{{formData.monthCash || 0}}分</div>
          <div>历史提现：{{formData.cash || 0}}分</div>
        </div>
      </div>
    </div>
    <div class="score-div">
      <ul>
        <li
          @click="checkLi(item)"
          :class="onLi==item.type?'div-li div-onli':' div-li'"
          v-for="(item,index) in liList"
          :key="index"
        >{{item.name}}</li>
      </ul>
      <div class="on-select">
        <div class="select-div1">
          <div class="select-div" @click="checkTime">{{selectTime}}</div>
          <div v-if="onLi=='income'" class="select-div" @click="checkType">类型：{{selectType}}</div>
        </div>
        <div class="score-sum">统计：{{currentTotal}}分</div>
      </div>
      <div v-if="onLi=='income'" class="score-con">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="con-box" v-for="(item,index) in dataList" :key="index">
              <div>积分：{{item.points}}</div>
              <div>类型：{{item.type}}</div>
              <div>产品名称：{{item.productName}}</div>
              <div>客户姓名：{{item.cusName}}</div>
              <div>订单号：{{item.orderNo}}</div>
              <div>发放时间：{{item.grantTime}}</div>
              <van-tag v-if="item.type=='贷款'" color="#C3C3FC">{{item.type}}</van-tag>
              <van-tag v-if="item.type=='保险'" color="#6DEDA2">{{item.type}}</van-tag>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-if="onLi=='cash'" class="score-con">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="con-box con-box2" v-for="(item,index) in dataList" :key="index">
              <div>提现积分：{{item.cashAmount}}</div>
              <div>剩余积分：{{item.restAmount}}</div>
              <div>提现时间：{{item.createTime}}</div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="showDate = false"
        @confirm="onConfirm"
      >
        <template #columns-bottom>
          <div class="pop-bottom">
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>
    <van-popup v-model="showType" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmType"
        @cancel="showType = false"
      >
      <template #columns-bottom>
          <div class="pop-bottom">
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import URL from "@/api/api";
import { Dialog } from 'vant';
import { setLocal } from "@/utils/utils";

export default {
  data() {
    return {
      bindingCardFlag: '',//是否绑定银行卡
      liList: [
        { type: 'income', name: '收入记录' },
        { type: 'cash', name: '提现记录' },
      ],
      onLi: 'income',
      income: true,//true为收入记录
      maxDate: new Date(),
      currentDate: new Date(),
      showDate: false,//时间弹框
      selectTime: this.timeFormat(new Date()),//选中时间
      columns: ['全部', '贷款', '保险'],
      showType: false,
      selectType: '全部',
      listType: 'loan',//类型绑定传值
      listDate: this.timeFormat1(new Date()),//时间绑定传值
      formData: {},//数据渲染
      dataList: [],//数据列表渲染
      currentTotal: '0',//数据列表统计
      page: 1,//当前页数
      size: 10,//每页几条数据
      total: 0,//总页数
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted(){
    this.checkOpenid()
  },
  methods: {
    onLoad() {//首次加载
      if (this.income) {//收入记录
        this.getIncomeData()
      } else {
        this.getCashData()
      }
    },
    onRefresh() {//下拉加载
      this.page = 1
      this.loading = true
      this.finished = false
      if (this.income) {//收入记录
        this.getIncomeData()
      } else {
        this.getCashData()
      }
    },
    getIncomeData() {//收入记录数据
      this.getData()
    },
    getCashData() {//提现记录数据
      this.getData()
    },
    getData() {
      let that = this
      let data = {
        page: that.page,
        size: that.size,
        agentPhone: localStorage.getItem('phone'),
        dateType: that.onLi,//income=收入记录 cash=提现记录
        listDate: that.listDate, // 时间
        listType: that.selectType //loan=贷款 insure=保险
      }
      that.$fetchPost(URLTB.myScores.url, data).then(res => {
        if (res.data.code == 20000) {
          that.refreshing = false
          that.loading = false
          that.formData = res.data.data.accountInfo
          that.currentTotal = res.data.data.currentTotal
          let list = res.data.data.pageInfo.records
          that.total = res.data.data.pageInfo.total
          if (list == null || list.length == 0) {
            // 加载结束
            that.finished = true
            return
          }
          if (that.page > 1) {
            that.dataList = [...that.dataList, ...list]
          } else {
            that.dataList = list
          }
          // 如果当前数据>=总条数 加载结束
          if (that.size * that.page >= that.total) {
            that.finished = true
            return
          }
          // 如果当前数据<总条数 页数+1
          if (that.size * that.page < that.total) {
            that.page++
          }
        }

      })
    },
    checkOpenid() {
      let openid = localStorage.getItem("openid");
      this.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
        if (res.data.code == 20000) {
          this.bindingCardFlag = res.data.data.bindingCardFlag
          setLocal("cip", res.data.data.ip);
        }
      });
    },
    withdrawal() {//积分提现
      if (this.bindingCardFlag != '1') {
        Dialog.confirm({
          title: '银行卡授权',
          message: '提现功能需要进行银行卡授权，请进行授权',
        })
          .then(() => {
            // on confirm
            this.$router.push('/bankCard/details')
          })
          .catch(() => {
            // on cancel
          });
          return
      }
      this.$router.push({ path: '/withdrawal', query: { balance: this.formData.balance } })
    },
    checkLi(item) {//li选择
      this.onLi = item.type
      if (!item.type) {
        this.income = true
        this.dataList = []
        this.page = 1
        this.loading = true
        this.finished = false
        this.getIncomeData()
      } else {
        this.income = false
        this.dataList = []
        this.page = 1
        this.loading = true
        this.finished = false
        this.getCashData()
      }
    },
    checkTime() { //时间选择
      this.showDate = true
    },
    checkType() { //类型选择
      this.showType = true
    },
    onConfirmType(value) {//类型选择确认
      this.selectType = value
      if (value == '全部') {
        this.listType = 'loan'
      } else if (value == '贷款') {
        this.listType = 'loan'
      } else {
        this.listType = 'insure'
      }
      this.showType = false
      this.getData()
    },
    // cancel(){//日期选择取消
    //   this.showDate = false
    // },
    onConfirm(time) {//日期选择确认
      this.selectTime = this.timeFormat(time)
      this.listDate = this.timeFormat1(time)
      this.showDate = false
      this.getData()
    },
    timeFormat(time) { // 时间格式化 2019-09-08de
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      return year + "年" + month + '月';
    },
    timeFormat1(time) { // 时间格式化 2019-09-08de
      return `${time.getFullYear()}-${("0" + (time.getMonth() + 1)).slice(-2)}-${('0' + (time.getDate())).slice(-2)} ${("0" + (time.getHours())).slice(-2)}:${("0" + (time.getMinutes())).slice(-2)}:${("0" + (time.getSeconds())).slice(-2)}`
    },
    formatter(type, val) {//时间选择
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
  }
}
</script>

<style lang="less" scoped>
.my-scores {
  height: 100vh;
  background: #ffffff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  .score-top {
    width: 375px;
    height: 168px;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    color: #ffffff;
    .top-top {
      height: 120px;
      text-align: center;
      overflow: hidden;
      .top-num {
        margin-top: 19px;
        font-family: DIN Alternate;
        font-weight: bold;
        font-size: 24px;
      }
      .top-s {
        font-weight: 500;
        font-size: 9px;
      }
      .top-but {
        width: 123px;
        height: 30px;
        margin: 13px auto auto;
        background: url("./img/but.png") no-repeat 100%;
        background-size: 100% 100%;
      }
    }
    .top-sta {
      font-weight: 400;
      font-size: 0.29333rem;
      display: flex;
      border-top: 1px solid #fff;
      align-items: center;
      .sta-div {
        width: 50%;
        text-align: center;
        padding: 7px 0;
        &:first-child {
          border-right: 1px solid #fff;
        }
      }
    }
  }
  .score-div {
    width: 355px;
    margin: auto;
    ul {
      display: flex;
      margin-top: 15px;
      .div-li {
        width: 178px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        background: url("./img/bg1.png") no-repeat 100%;
        background-size: 100% 100%;
      }
      .div-onli {
        background: url("./img/bg2.png") no-repeat 100%;
        color: #ffffff;
        // background-size: 100% 100%;
      }
    }
    .on-select {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      font-weight: 400;
      font-size: 11px;
      color: #666666;
      .select-div1 {
        display: flex;
        .select-div {
          width: 70px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: url("./img/bg3.png") no-repeat 100%;
          background-size: 100% 100%;
          &:nth-child(2) {
            margin-left: 5px;
          }
        }
      }
      .score-sum {
        color: #333333;
      }
    }
    .score-con {
      margin-top: 5px;
      font-weight: 400;
      font-size: 11px;
      color: #666666;
      .con-box {
        width: 355px;
        height: 110px;
        margin-top: 10px;
        background: url("./img/bg4.png") no-repeat 100%;
        background-size: 100% 100%;
        align-items: center;
        padding-top: 10px;
        position: relative;
        div {
          padding-left: 10px;
        }
        .van-tag {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .con-box2 {
        height: 65px;
      }
    }
  }
  .van-popup{
    .pop-bottom{
      height: 75px;
      text-align: center;
    }
    .pop-but{
      .van-button{
        width: 83px;
        height: 35px;
        line-height: 35px;
        &:last-child{
          // margin-left: 25px;
        }
      }
    }
    /deep/ .van-picker__toolbar{
      position: absolute;
      bottom: 35px;
      left: 50%;
      transform: translateX(-50%);
    }
   /deep/ .van-picker__cancel,/deep/ .van-picker__confirm {
        width: 83px;
        height: 35px;
        line-height: 35px;
    }
   /deep/  .van-picker__cancel{
      border: 1px solid #F96133;
      color: #FC6C21 !important;
    }
    /deep/ .van-picker__confirm{
      margin-left: 25px;
      background: linear-gradient(to bottom, #ff6034, #ee0a24);
      color: #fff !important;
    }
  }
}
</style>